import { render, staticRenderFns } from "./ChartsType1.vue?vue&type=template&id=1a83a12d&scoped=true"
import script from "./ChartsType1.vue?vue&type=script&lang=js"
export * from "./ChartsType1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a83a12d",
  null
  
)

export default component.exports